export default __webpack_public_path__ + "locales/lo-LA/ArchiveDialog.json?hash=b2d22d90b3ea90cff72cb71f4a9d9e7d";